function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#report_benchmark_svg__clip0_2981_4028)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M66.667.5H13.333C5.97.5 0 6.47 0 13.833v53.334C0 74.53 5.97 80.5 13.333 80.5h53.334C74.03 80.5 80 74.53 80 67.167V13.833C80 6.47 74.03.5 66.667.5z",
  fill: "#FEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.242 61.014h45",
  stroke: "#DD3939",
  strokeWidth: 2.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.559 61.014v-13.63c0-.949.77-1.718 1.719-1.718h2.547c.95 0 1.719.77 1.719 1.719v13.629m4.668 0l.277-20.774a1.719 1.719 0 011.719-1.696h2.45c.95 0 1.719.77 1.719 1.72v20.504m4.728.246v-13.63c0-.949.77-1.718 1.72-1.718h2.487c.949 0 1.719.77 1.719 1.719v13.629m4.967 0V44.499c0-.949.77-1.718 1.72-1.718h2.307c.95 0 1.72.77 1.72 1.718v16.515",
  stroke: "#DD3939",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23.015,
  cy: 33.019,
  r: 2.433,
  stroke: "#DD3939",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34.187,
  cy: 24.67,
  r: 2.433,
  stroke: "#DD3939",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45.363,
  cy: 33.019,
  r: 2.433,
  stroke: "#DD3939",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56.406,
  cy: 30.195,
  r: 2.433,
  stroke: "#DD3939",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.223 31.423l6.63-5.218m4.727.307l6.446 4.91m5.218 1.413l5.403-2.087",
  stroke: "#DD3939",
  strokeWidth: 2.5
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "report_benchmark_svg__clip0_2981_4028"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .5)",
  d: "M0 0h80v80H0z"
})));

var SvgReportBenchmark = function SvgReportBenchmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 80 81",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgReportBenchmark;